import { AudioPlayback } from '@components/ui';
import React from 'react';

import { CellRenderer, CellRenderProps, CellValue } from '../types';

const AUDIO_COLUMN_RE = /audio_recording/i;

const isIntegerLike = (value: CellValue): boolean => {
  if (typeof value === 'number') return Number.isInteger(value);
  if (typeof value === 'string') return /^\d+$/.test(value.trim());
  return false;
};

const toId = (value: CellValue): number | null => {
  if (typeof value === 'number' && Number.isInteger(value)) return value;
  if (typeof value === 'string') {
    const n = parseInt(value.trim(), 10);
    return Number.isNaN(n) ? null : n;
  }
  return null;
};

const isEmpty = (value: CellValue): boolean => value === null || value === undefined || value === '';

const Cell = ({ value }: CellRenderProps) => {
  if (isEmpty(value)) return <span>—</span>;
  const id = toId(value);
  if (id === null) return <span>{String(value)}</span>;
  return <AudioPlayback id={id} />;
};

export const audioRecordingRenderer: CellRenderer = {
  kind: 'audio',
  detect: (samples, columnName) => {
    if (!columnName || !AUDIO_COLUMN_RE.test(columnName)) return false;
    return samples.length > 0 && samples.every(isIntegerLike);
  },
  Compact: Cell,
  Expanded: Cell,
  Full: Cell,
};
